import BasicList from 'core/modules/components/lists/components/BasicList/BasicList';
import AssessmentItem from 'core/modules/components/lists/assessments/AssessmentItem/AssessmentItem';
import { stripHtml } from 'core/utils/utils';
import React from 'react';

/**
 * AssessmentsList - Lista de evaluaciones/tareas del alumno. Envuelve el genérico v2
 * `BasicList` (semántica `<ul>/<li>` accesible) y renderiza cada assessment dentro de un
 * `<button>` accesible (focusable + activable por teclado), en vez del antiguo `<div onClick>`
 * sin `role`/`tabIndex`. Mismo patrón de accesibilidad que `TaskList`.
 */

export type Assessment = Readonly<{
  lesson_item_guid?: string;
  title?: string;
  lessonName?: string;
  course?: { education_discipline_name?: string; [key: string]: unknown };
  dueDate?: string;
  status?: string;
  type?: string;
  grade?: string | null;
  gradeTotal?: string;
  questionsLength?: number;
  lesson_item_content_is_evaluable?: boolean;
  lesson_item_content_type_guid?: string;
  consumed_at?: string;
  data?: unknown;
  [key: string]: unknown;
}>;

type AssessmentsListProps = Readonly<{
  assessments?: Assessment[];
  onClick?: (assessment: Assessment) => void;
}>;

function getAssessmentLabel(assessment: Assessment): string | undefined {
  return [assessment.lessonName, assessment.title].map((value) => stripHtml(value ?? '')).filter(Boolean).join(' - ') || undefined;
}

function AssessmentsList({ assessments = [], onClick = () => {} }: AssessmentsListProps): JSX.Element {
  return (
    <div className="assessments-list">
      <BasicList
        items={assessments.map((assessment) => (
          <button
            type="button"
            className="button-accessibility-only lesson-task-list__task lesson-task-list__task-button"
            aria-label={getAssessmentLabel(assessment)}
            key={assessment.lesson_item_guid}
            onClick={() => onClick(assessment)}
          >
            <AssessmentItem {...assessment} />
          </button>
        ))}
      />
    </div>
  );
}

export default AssessmentsList;
